import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ServiceBase } from './service.base';

@Injectable({
    providedIn: 'root'
})
export class PlanoRecuperacaoJudicialService extends ServiceBase {

    public endpoint = 'planoRecuperacaoJudicial/';

    constructor(private http: HttpClient) {
        super();
    }

    obterPorRecursoDescobramento(id) {
        return this.http
            .get(environment.api + this.endpoint + `recurso-desdobramento/${id}`)
            .pipe(map(this.extractData), catchError(this.serviceError));
    }
}
